<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #DBECDB;">
          <h5 class="card-title">Registro de Entradas</h5>
          <div class="row mb-3">
            <div class="col-md-12">
              <div class="row g-2">
                <!-- Filtro por rango de fechas -->
                <div class="col-md-2">
                  <label class="form-label small">Fecha desde</label>
                  <input 
                    type="date" 
                    v-model="filters.fecha_inicio" 
                    class="form-control form-control-sm"
                  >
                </div>
                <div class="col-md-2">
                  <label class="form-label small">Fecha hasta</label>
                  <input 
                    type="date" 
                    v-model="filters.fecha_fin" 
                    class="form-control form-control-sm"
                  >
                </div>
                <!-- Filtro por preventivo -->
                <div class="col-md-2">
                  <label class="form-label small">Preventivo</label>
                  <input 
                    type="text" 
                    v-model="filters.preventivo" 
                    class="form-control form-control-sm" 
                    placeholder="N° preventivo"
                  >
                </div>
                <!-- Filtro por partida -->
                <div class="col-md-3">
                  <label class="form-label small">Categoria</label>
                  <select v-model="filters.categoria" class="form-select">
                    <option value="">Todas</option>
                    <option v-for="cat in categorias" :key="cat.id" :value="cat.id">
                      {{ cat.nombre_categoria }}
                    </option>
                  </select>
                </div>
                
                <!-- Filtro por proveedor -->
                <div class="col-md-3">
                  <label class="form-label small">Proveedor</label>
                  <select 
                    v-model="filters.proveedor" 
                    class="form-select form-select-sm"
                  >
                    <option value="">Todos</option>
                    <option 
                      v-for="prov in proveedores" 
                      :key="prov.id" 
                      :value="prov.id"
                    >
                      {{ prov.razon_social }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-8">
              <div class="form-group">
                <div class="input-group">
                  <input 
                    v-model="filters.search" 
                    type="text" 
                    class="form-control" 
                    placeholder="Buscar por descripcion..."
                  >
                  <!-- Botón de búsqueda -->
                  <button 
                    @click="applyFilters" 
                    class="btn btn-primary btn-sm me-2"
                  >
                    <i class="fa fa-search me-1"></i>Buscar
                  </button>
                  <!-- Botón de limpiar -->
                  <button 
                    @click="resetFilters" 
                    class="btn btn-secondary btn-sm"
                  >
                    <i class="fa fa-times me-1"></i>Limpiar
                  </button>
                </div>
              </div>
            </div>
            
            <div class="col-md-4 text-end">
              <BButton
                @click="showModal(null)"
                v-if="hasPermission('entrada_create')"
                variant="primary"
                class="btn-round me-2"
              >
                <i class="fa fa-plus me-1"></i> Nueva Entrada
              </BButton>
              <BButton
                variant="danger"
                class="btn-round"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>
        </div>
        
        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>
          
          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered">
                <thead class="text-primary">
                  <tr style="line-height: 8px; font-size: 0.75rem;">
                    <th>Nro</th>
                    <th>Fecha</th>
                    <th>Prev.</th>
                    <th>Descripcion</th>
                    <th>Proveedor</th>
                    <th>Partida</th>
                    <th>Categoría</th>
                    <th>Items</th>
                    <th>Estado</th>
                    <th>Disponible</th>
                    <th>Acta</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="entrada in entradas.data" :key="entrada.id" style="font-size: 0.85rem;">
                    <td>{{ entrada.numero }}</td>
                    <td>{{ formatDate(entrada.fecha_entrada) }}</td>
                    <td>{{ entrada.compra.nro_preventivo }}</td>
                    <td>{{ entrada.compra.acta_entrega }}</td>
                    <td>{{ entrada.compra.proveedores.razon_social }}</td>
                    <td>{{ entrada.compra.categoria.id_partida }}</td>
                    <td>{{ entrada.compra.categoria.nombre_categoria }}</td>
                    <td>{{ entrada.detalles.length }}</td>
                    <td>
                      <span 
                        class="badge" 
                        :class="{
                          'bg-warning': entrada.estado === 'Iniciado',
                          'bg-success': entrada.estado === 'Confirmado'
                        }"
                      >
                        {{ entrada.estado }}
                      </span>
                    </td>
                    <td>
                      <span 
                        v-if="entrada.disponible === 'si'"
                        class="badge bg-success"
                      >
                        <i class="fa fa-check-circle me-1"></i> Disponible
                      </span>
                      <span 
                        v-else-if="entrada.disponible === 'no'"
                          class="badge bg-secondary"
                        >
                          <i class="fa fa-times-circle me-1"></i> No Disponible
                        </span>
                        <span 
                          v-else
                          class="badge bg-secondary"
                        >
                        No Disponible
                      </span>
                    </td>
                    <td>
                      <BButton
                          v-if="entrada.estado == 'Confirmado'"
                          variant="success"
                          class="btn btn-sm"
                          @click="generateActaPDF(entrada.id)"
                        >
                          <i class="fa fa-file-pdf me-1"></i>
                      </BButton>
                    </td>
                    <td>
                      <div class="btn-group">
                        <BButton
                          
                          @click="showDetails(entrada)"
                          variant="info"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-eye"></i>
                        </BButton>
                        <BButton
                          v-if="entrada.estado === 'Confirmado' && entrada.disponible !== 'si'"
                          @click="toggleDisponible(entrada)"
                          variant="success"
                          size="sm"
                          class="me-1"
                          title="Habilitar disponible"
                        >
                          <i class="fa fa-check-circle"></i>
                        </BButton>
                        <BButton
                          v-if="entrada.estado == 'Iniciado' && hasPermission('entrada_update')"
                          @click="showModal(entrada)"
                          variant="warning"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-edit"></i>
                        </BButton>
                        <BButton
                          v-if="entrada.estado == 'Iniciado' && hasPermission('entrada_delete')"
                          @click="confirmDelete(entrada)"
                          variant="danger"
                          size="sm"
                        >
                          <i class="fa fa-trash"></i>
                        </BButton>
                        <BButton
                          v-if="entrada.estado == 'Iniciado' && hasPermission('entrada_create')"
                          @click="confirmRecepcion(entrada)"
                          variant="success"
                          size="sm"
                        >
                          <i class="fa fa-check"></i>
                        </BButton>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <!-- Paginación -->
            <div class="row mt-3" v-if="entradas.total > 0">
              <div class="col-md-5">
                <div class="text-center mt-2">
                  <small class="text-muted">
                    Mostrando {{ entradas.data.length }} de {{ entradas.total }} registros
                    (Página {{ entradas.current_page }} de {{ entradas.last_page }})
                  </small>
                </div>
              </div>
              <div class="col-md-7">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="entradas.total"
                  :per-page="pagination.per_page"
                  @update:model-value="handlePageChange"
                  align="center"
                  :aria-label="'Paginación de entradas'"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para crear/editar -->
    <BModal
      v-model="modalVisible"
      :title="modalTitle"
      size="xl"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Fecha Entrada</label>
              <input
                type="date"
                v-model="form.fecha_entrada"
                class="form-control"
                :class="{ 'is-invalid': errors.fecha_entrada }"
                required
              />
              <div class="invalid-feedback" v-if="errors.fecha_entrada">
                {{ errors.fecha_entrada[0] }}
              </div>
            </div>
          </div>
          
          <div class="col-md-8">
            <div class="form-group">
              <label class="form-label">Compra</label>
              <select
                v-model="form.id_compra"
                class="form-select"
                :class="{ 'is-invalid': errors.id_compra }"
                required
                @change="loadCompraDetails"
              >
                <option value="">Seleccione una compra</option>
                <!-- Opción para la compra asociada (si está en modo edición) -->
                <option 
                  v-if="isEditing && form.id_compra && !comprasDisponibles.some(c => c.id == form.id_compra)"
                  :value="form.id_compra"
                  disabled
                >
                  {{ getCompraAsociadaLabel() }} (Asociada a esta entrada)
                </option>
                <option 
                  v-for="compra in comprasDisponibles" 
                  :key="compra.id" 
                  :value="compra.id.toString()"
                >
                  {{ compra.nro_preventivo }} - {{ compra.acta_entrega }} 
                  ({{ compra.categoria?.nombre_categoria || '' }})
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.id_compra">
                {{ errors.id_compra[0] }}
              </div>
            </div>
          </div>
        </div>
        
        <div class="row mt-3">
          <div class="col-md-12">
            <h5>Items de la Entrada</h5>
            <div class="table-responsive">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr style="line-height: 8px; font-size: 0.8rem;">
                    <th rowspan="2">Item</th>
                    <th colspan="2">Cantidad</th>
                    <th>Unidad</th>
                    <th v-if="showSeriesFields">de</th>
                    <th v-if="showSeriesFields">a</th>
                    <th v-if="showSeriesFields" rowspan="2">Serie</th>
                    <th v-if="showSeriesFields" rowspan="2">Origen</th>
                    <th rowspan="2">Accion</th>
                  </tr>
                  <tr style="line-height: 8px; font-size: 0.8rem;">
                    <th>Comprada</th>
                    <th>Recibida</th>
                    <th>Medida</th>
                    <th v-if="showSeriesFields">Nro</th>
                    <th v-if="showSeriesFields">Nro</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in form.items" :key="index"  style="line-height: 8px; font-size: 0.8rem;">
                    <td>
                      <select
                        v-model="item.id_item"
                        class="form-select form-select-sm"
                        required
                        @change="updateItemDetails(index)"
                      >
                        <option value="">Seleccione un item</option>
                        <option 
                          v-for="i in itemsDisponibles" 
                          :key="i.id" 
                          :value="i.id"
                        >
                          {{ i.codigo }}: {{ i.nombre_item }}
                        </option>
                      </select>
                    </td>
                    <td>
                      {{ item.cantidad_comprada || 0 }}
                    </td>
                    <td>
                      <input
                        type="number"
                        v-model="item.cantidad"
                        :max="item.cantidad_comprada"
                        min="1"
                        class="form-control form-control-sm"
                        required
                      />
                    </td>
                    <td>
                      {{ getItemById(item.id_item)?.unidad_medida || '-' }}
                    </td>
                    <td v-if="showSeriesFields">
                      <input
                        type="number"
                        v-model="item.de_nro"
                        class="form-control form-control-sm"
                        :required="showSeriesFields"
                      />
                    </td>
                    <td v-if="showSeriesFields" >
                      <input
                        type="number"
                        v-model="item.a_nro"
                        class="form-control form-control-sm"
                        :required="showSeriesFields"
                      />
                    </td>
                    <td v-if="showSeriesFields">
                      <select
                        v-model="item.serie"
                        class="form-select form-select-sm"
                        :required="showSeriesFields"
                      >
                        <option value="">Seleccione</option>
                        <option v-for="letter in seriesLetters" :value="letter">
                          {{ letter }}
                        </option>
                      </select>
                    </td>
                    <td v-if="showSeriesFields">
                      <select
                        v-model="item.origen"
                        class="form-select form-select-sm"
                        :required="showSeriesFields"
                      >
                        <option value="">Seleccione</option>
                        <option value="DDE">DDE-BENI</option>
                        <option value="MINEDU">Min. Eduacion</option>
                      </select>
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        @click="removeItem(index)"
                        v-if="form.items.length > 1"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4"></td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-success btn-sm"
                        @click="addItem"
                      >
                        <i class="fa fa-plus"></i> Agregar
                      </button>
                    </td>
                  </tr>
                </tfoot>
              </table>
              <div class="text-danger" v-if="errors.items">
                {{ errors.items[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="modalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditing ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>

    <!-- Modal para detalles -->
    <BModal
      v-model="detailsModalVisible"
      title="Detalles de Entrada"
      size="lg"
      centered
      hide-footer
    >
      <div v-if="selectedEntrada">
        <div class="row">
          <div class="col-md-6">
            <p><strong>Fecha Entrada:</strong> {{ formatDate(selectedEntrada.fecha_entrada) }}</p>
            <p><strong>Preventivo:</strong> {{ selectedEntrada.compra.nro_preventivo }}</p>
            <p><strong>Partida:</strong> {{ selectedEntrada.compra.partida_presupuestaria }}</p>
          </div>
          <div class="col-md-6">
            <p><strong>Proveedor:</strong> {{ selectedEntrada.compra.proveedores.razon_social }}</p>
            <p><strong>Categoría:</strong> {{ selectedEntrada.compra.categoria.nombre_categoria }}</p>
            <!--<p><strong>Registrado por:</strong> {{ selectedEntrada.usuario_registro }}</p>-->
          </div>
        </div>
        
        <div class="row mt-3">
          <div class="col-md-12">
            <h5>Items Recibidos</h5>
            <div class="table-responsive">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th rowspan="2">Item</th>
                    <th colspan="2">Cantidad</th>
                    <th>Unidad</th>
                    <th>de</th>
                    <th>a</th>
                    <th rowspan="2">Serie</th>
                    <th rowspan="2">Origen</th>
                  </tr>
                  <tr>
                    <th>Comprada</th>
                    <th>Recibida</th>
                    <th>Medida</th>
                    <th>Nro</th>
                    <th>Nro</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(detalle, index) in selectedEntrada.detalles" :key="index">
                    <td>{{ detalle.item.codigo }}: {{ detalle.item.nombre_item }}</td>
                    <td>{{ detalle.cantidad }}</td>
                    <td>{{ detalle.cantidad }}</td>
                    <td>{{ detalle.item.unidad_medida }}</td>
                    <td v-if="detalle.de_nro">{{ detalle.de_nro }}</td>
                    <td v-if="detalle.a_nro">{{ detalle.a_nro }}</td>
                    <td v-if="detalle.serie">{{ detalle.serie }}</td>
                    <td v-if="detalle.origen">{{ detalle.origen }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </BModal>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, nextTick, watch } from 'vue';
import axios from 'axios';
import { useAuthStore } from '@/stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BPagination, BFormCheckbox } from 'bootstrap-vue-3';

// Store
const authStore = useAuthStore();

// Datos
const entradas = ref({
  data: [],
  current_page: 1,
  per_page: 10,
  total: 0,
  last_page: 1
});
const categorias = ref([]);
const comprasDisponibles = ref([]);
const itemsDisponibles = ref([]);
const loading = ref(true);
const loadingForm = ref(false);
const modalVisible = ref(false);
const detailsModalVisible = ref(false);
const isEditing = ref(false);
const errors = ref({});
const selectedEntrada = ref(null);
const filters = ref({
  search: '',
  fecha_inicio: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
  fecha_fin: new Date().toISOString().split('T')[0],
  preventivo: '',
  partida: '',
  categoria: '',
  proveedor: ''
});

const pagination = ref({
  current_page: 1,
  per_page: 10,
  total: 0
});

const proveedores = ref([]);
// Formulario
const form = ref({
  id: null,
  fecha_entrada: new Date().toISOString().split('T')[0],
  id_compra: '',
  items: [
    { id_item: '', cantidad: 1, cantidad_comprada: 0 }
  ]
});

// Nuevos métodos
const applyFilters = () => {
  pagination.value.current_page = 1; // Resetear a primera página
  fetchEntradas();
};
const resetFilters = () => {
  filters.value = {
    fecha_inicio: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
    fecha_fin: new Date().toISOString().split('T')[0],
    preventivo: '',
    partida: '',
    categoria: '',
    proveedor: ''
  };
  pagination.value.current_page = 1;
  fetchEntradas();
};
const fetchProveedores = async () => {
  try {
    const response = await axios.get('/proveedor/select');
    proveedores.value = response.data.data;
  } catch (error) {
    console.error('Error al cargar proveedores:', error);
  }
};
const fetchCategorias = async () => {
  try {
    const response = await axios.get('/compras/categorias');
    categorias.value = response.data.data;
  } catch (error) {
    console.error('Error al cargar categorías:', error);
  }
};


// Computed
const modalTitle = computed(() => {
  return isEditing.value ? 'Editar Entrada' : 'Nueva Entrada';
});

const showSeriesFields = computed(() => {
  if (!form.value.id_compra) return false;
  const compra = comprasDisponibles.value.find(c => c.id == form.value.id_compra);
  if (!compra && isEditing.value && selectedEntrada.value) {
    return selectedEntrada.value.compra.categoria.id_partida === '25600';
  }
  return compra?.categoria.id_partida === '25600';
});

const seriesLetters = computed(() => {
  return Array.from({length: 26}, (_, i) => String.fromCharCode(65 + i));
});
// Métodos
const fetchEntradas = async () => {
  loading.value = true;
  try {
    const params = {
      page: pagination.value.current_page,
      per_page: pagination.value.per_page,
      ...filters.value
    };

    const response = await axios.get('/entradas/list', { params });
    
    // La estructura correcta es response.data.data
    if (response.data && response.data.data) {
      entradas.value = {
        data: response.data.data.data,
        current_page: response.data.data.current_page,
        per_page: response.data.data.per_page,
        total: response.data.data.total,
        last_page: response.data.data.last_page
      };
      
      // Actualizar el objeto pagination para el control de paginación
      pagination.value = {
        current_page: entradas.value.current_page,
        per_page: entradas.value.per_page,
        total: entradas.value.total
      };
    }
    
  } catch (error) {
    console.error('Error al cargar entradas:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'No se pudieron cargar las entradas'
    });
  } finally {
    loading.value = false;
  }
};

const fetchComprasDisponibles = async () => {
  try {
    const response = await axios.get('/entradas/disponibles');
    comprasDisponibles.value = response.data.data;
    console.log(comprasDisponibles);
  } catch (error) {
    console.error('Error al cargar compras disponibles:', error);
  }
};

const loadCompraDetails = async () => {
  if (!form.value.id_compra) {
    itemsDisponibles.value = [];
    return;
  }
  try {
    const response = await axios.get(`/compras/${form.value.id_compra}/ver`);
    const compra = response.data.data;
    // Cargar items de la compra
    itemsDisponibles.value = compra.detalles.map(d => ({
      ...d.item,
      cantidad_comprada: d.cantidad
    }));
    // Si es nueva entrada, prellenar con items de la compra
    if (!isEditing.value) {
      form.value.items = compra.detalles.map(d => ({
        id_item: d.id_item,
        cantidad: d.cantidad,
        cantidad_comprada: d.cantidad,
        de_nro: null,
        a_nro: null,
        serie: 'A',
        origen: 'DDE'
      })); 
      // Forzar la actualización de la UI después de cambiar los items
      await nextTick();
    } 
  } catch (error) {
    console.error('Error al cargar detalles de compra:', error);
  }
};

watch(() => form.value.id_compra, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    // Forzar la actualización de la UI
    nextTick(() => {
      // Esto asegurará que los campos se muestren/oculten correctamente
    });
  }
});

const getItemById = (id) => {
  return itemsDisponibles.value.find(item => item.id === id);
};

const updateItemDetails = (index) => {
  const itemId = form.value.items[index].id_item;
  if (itemId) {
    const item = getItemById(itemId);
    if (item) {
      form.value.items[index].cantidad_comprada = item.cantidad_comprada;
      form.value.items[index].cantidad = item.cantidad_comprada;
    }
  }
};

const addItem = () => {
  form.value.items.push({ id_item: '', cantidad: 1, cantidad_comprada: 0 });
};

const removeItem = (index) => {
  if (form.value.items.length > 1) {
    form.value.items.splice(index, 1);
  }
};

const showModal = async(entrada) => {
  errors.value = {};
  if (entrada) {
    // Edición - Cargar la entrada completa con sus relaciones
    try {
      const response = await axios.get(`/entradas/${entrada.id}/ver`);
      const entradaCompleta = response.data.data;
      const compraAsociada = entradaCompleta.compra;
      
      // 4. Agregar la compra asociada a las opciones del select si no existe
      const compraYaExiste = comprasDisponibles.value.some(c => c.id === compraAsociada.id);
      if (!compraYaExiste) {
        comprasDisponibles.value.unshift({
          ...compraAsociada,
          isAssociated: true // Marcar como compra asociada
        });
      }

      isEditing.value = true;
      form.value = {
        id: entradaCompleta.id,
        fecha_entrada: formatDateForInput(entradaCompleta.fecha_entrada),
        id_compra: compraAsociada.id.toString(),
        items: entradaCompleta.detalles.map(d => ({
          id_item: d.id_item,
          cantidad: d.cantidad,
          cantidad_comprada: d.cantidad, // O usar getCantidadComprada si es diferente
          de_nro: d.de_nro || null,
          a_nro: d.a_nro || null,
          serie: d.serie || null,
          origen: d.origen || null
        }))
      };
      
      // Cargar los items disponibles para esta compra
      await loadCompraDetails();
      // Esperar a que el select se renderice
      await nextTick();
      // Forzar actualización del select
      form.value.id_compra = entradaCompleta.id_compra.toString();
    } catch (error) {
      console.error('Error al cargar entrada:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo cargar la entrada para edición'
      });
      return;
    }
  } else {
    // Nuevo
    isEditing.value = false;
    form.value = {
      id: null,
      fecha_entrada: new Date().toISOString().split('T')[0],
      id_compra: '',
      items: [
        { id_item: '', cantidad: 1, cantidad_comprada: 0 }
      ]
    };
  }
  modalVisible.value = true;
};

const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toISOString().split('T')[0];
};

const getCantidadComprada = (id_item) => {
  if (!form.value.id_compra) return 0;
  
  const compra = comprasDisponibles.value.find(c => c.id === form.value.id_compra);
  if (!compra) return 0;
  
  const detalle = compra.detalles.find(d => d.id_item === id_item);
  return detalle ? detalle.cantidad : 0;
};

const showDetails = (entrada) => {
  selectedEntrada.value = entrada;
  detailsModalVisible.value = true;
};

const handleSubmit = async () => {
  loadingForm.value = true;
  errors.value = {};

  try {
    let response;
    
    if (isEditing.value && form.value.id) {
      response = await axios.post(`/entradas/${form.value.id}/update`, form.value);
    } else {
      response = await axios.post('/entradas/save', form.value);
    }
    
    Swal.fire({
      icon: 'success',
      title: 'Éxito',
      text: response.data.message
    });
    
    modalVisible.value = false;
    fetchEntradas();
  } catch (error) {
    if (error.response && error.response.status === 422) {
      errors.value = error.response.data.errors;
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
      });
    }
  } finally {
    loadingForm.value = false;
  }
};

const confirmRecepcion = (entrada) => {
  Swal.fire({
    title: '¿Está seguro?',
    text: `¿Desea confirmar la entrada del ${formatDate(entrada.fecha_entrada)}?`,
    icon: 'success',
    showCancelButton: true,
    confirmButtonColor: '#29ba47',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, confirmar',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      confirmarEntrada(entrada.id);
    }
  });
};

const toggleDisponible = async (entrada) => {
  const action = entrada.disponible === 'si' ? 'deshabilitar' : 'habilitar';
  
  Swal.fire({
    title: '¿Está seguro?',
    text: `¿Desea ${action} la entrada como disponible?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#28a745',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Sí, continuar',
    cancelButtonText: 'Cancelar'
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        const response = await axios.post(`/entradas/${entrada.id}/toggle-disponible`);
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });
        
        await fetchEntradas();
      } catch (error) {
        console.error('Error al cambiar disponibilidad:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo cambiar la disponibilidad'
        });
      }
    }
  });
};
const confirmDelete = (entrada) => {
  Swal.fire({
    title: '¿Está seguro?',
    text: `¿Desea eliminar la entrada del ${formatDate(entrada.fecha_entrada)}?`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      deleteEntrada(entrada.id);
    }
  });
};

const deleteEntrada = async (id) => {
  try {
    await axios.get(`/entradas/${id}/delete`);
    Swal.fire({
      icon: 'success',
      title: 'Entrada eliminada',
      text: 'La entrada ha sido eliminada correctamente'
    });
    await fetchEntradas();
  } catch (error) {
    console.error('Error al eliminar entrada:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.response?.data?.message || 'No se pudo eliminar la entrada'
    });
  }
};

const confirmarEntrada = async (id) => {
  try {
    await axios.post(`/entradas/${id}/confirmar`);
    Swal.fire({
      icon: 'success',
      title: 'Entrada confirmar',
      text: 'La entrada ha sido confirmado correctamente'
    });
    await fetchEntradas();
  } catch (error) {
    console.error('Error al confirmar entrada:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.response?.data?.message || 'No se pudo confirmar la entrada'
    });
  }
};

const handleSearch = () => {
  pagination.value.current_page = 1;
  fetchEntradas();
};

const handlePageChange = (page) => {
  if (page && page !== pagination.value.current_page) {
    pagination.value.current_page = page;
    fetchEntradas();
  }
};

const formatDate = (dateString) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  return new Date(dateString).toLocaleDateString('es-BO', options);
};
const generateActaPDF = async (id) => {
  try {
            const response = await axios.get(`/entradas/acta/${id}`, {
                responseType: 'blob'
            });
            
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'acta-entrada.pdf';
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error('Error al generar PDF:', error);
        }
};
const generatePDF = async () => {
  try {
    const params = {
      fecha_inicio: filters.value.fecha_inicio,
      fecha_fin: filters.value.fecha_fin,
      categoria: filters.value.categoria,
      proveedor: filters.value.proveedor
    };

    const response = await axios.get('/entradas/reporte/generar', {
      params,
      responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `reporte-entradas-${new Date().toISOString().split('T')[0]}.pdf`);
    document.body.appendChild(link);
    link.click();
    
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    console.error('Error al generar PDF:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'No se pudo generar el PDF'
    });
  }
};

const hasPermission = (permission) => {
  return authStore.hasPermission(permission);
};

// Ciclo de vida
onMounted(() => {
  fetchEntradas();
  fetchComprasDisponibles();
  fetchProveedores();
  fetchCategorias();
});


</script>

<style scoped>
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
  tbody td {
    margin: 0px;
    padding: 8px !important;
    vertical-align: middle;
  }
  .table-responsive {
    max-height: 600px;
    overflow-y: auto;
  }
  .btn-round {
    border-radius: 50px;
  }
</style>